/**
 * Return an extracted path from a passed state
 * Else return null
 * @param state the string value received from window.location.search
 * @returns
 */
export const getStatePathValue = (state: string): string | null => {
  try {
    const params = new URLSearchParams(state);
    const stateParam = params.get('state');
    const stateParsed: { [key: string]: string } | null = stateParam ? JSON.parse(stateParam) : null;
    const path = stateParsed ? stateParsed.path : null;
    const pathWithoutSlash = path === '/' ? null : path;

    return pathWithoutSlash;
  } catch (error) {
    return null;
  }
};
